"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../../helpers/getContentType");
const entity_1 = require("../../type/entity");
function _isGradable(offerData) {
    try {
        const contentType = getContentType_1.getContentType(offerData);
        if ('isGradable' in offerData) {
            switch (contentType) {
                case entity_1.ContentType.CARD_QUESTION:
                    // isGradable true and minScore and maxScore should be present
                    return offerData.isGradable && 'minScore' in offerData && 'maxScore' in offerData;
                case entity_1.ContentType.ASSIGNMENT_CARD:
                    // isGradable true and successCriteria and minScaledScore should be present
                    return offerData.isGradable && 'successCriteria' in offerData && 'minScaledScore' in offerData;
                case entity_1.ContentType.COURSE:
                case entity_1.ContentType.SECTION:
                    // isGradable true and successStatusRollupRules should be present
                    return (offerData.isGradable && offerData.successStatusRollupRules && offerData.successStatusRollupRules.length > 0);
                default:
                    return false;
            }
        }
        else {
            switch (contentType) {
                case entity_1.ContentType.CARD_QUESTION:
                    // isGradable true and minScore and maxScore should be present
                    return 'minScore' in offerData && 'maxScore' in offerData;
                case entity_1.ContentType.ASSIGNMENT_CARD:
                    // successCriteria and minScaledScore should be present
                    return offerData.successCriteria && offerData.minScaledScore;
                case entity_1.ContentType.COURSE:
                case entity_1.ContentType.SECTION:
                    // successStatusRollupRules should be present
                    return offerData.successStatusRollupRules && offerData.successStatusRollupRules.length > 0;
                default:
                    return false;
            }
        }
    }
    catch (error) {
        throw new Error('Error in isGradable ' + error);
    }
}
function isGradable(content) {
    return _isGradable(content);
}
exports.isGradable = isGradable;
//# sourceMappingURL=isGradable.js.map